import React from "react";
import ModulesSidebar from "./ModulesSidebar";
import MainSection from "./MainSection";
import LinksSidebar from "./LinksSidebar";
import KeyTermModal from "./KeyTermModal";
import ShareModal from "./ShareModal";
import { useSelector } from "react-redux";
import { AnimatePresence, motion } from "framer-motion";
import useWindowSize from "../../hooks/useWindowSize";
import ShareBadgeModal from "../badge/ShareBadgeModal";
import BadgeModal from "../badge/BadgeModal";
import SweepstakesModal from "../sweepstakes/SweepstakesModal";

const MainLayout = () => {
  const showShareModal = useSelector((state) => state.ui.showShareModal);
  const showShareBadgeModal = useSelector(
    (state) => state.ui.showShareBadgeModal
  );
  const showBadgeModal = useSelector((state) => state.ui.showBadgeModal);
  // TODO hidden until sweepstakes ready to deploy
  // const showSweepstakesModal = useSelector(
  //   (state) => state.ui.showSweepstakesModal
  // );
  const section = useSelector((state) => state.progress.section);
  const [width] = useWindowSize();

  return (
    <div className="font-primary text-base leading-normal text-gray-600 tracking-wide bg-color-main min-h-screen">
      <KeyTermModal />
      {showShareModal ? <ShareModal /> : null}
      {showShareBadgeModal ? <ShareBadgeModal /> : null}
      {showBadgeModal ? <BadgeModal /> : null}
      {/* TODO hidden until sweepstakes ready to deploy */}
      {/* {showSweepstakesModal ? <SweepstakesModal /> : null} */}

      <div className="w-full relative overflow-hidden">
        <div className="container mx-auto my-8">
          <div className="flex relative">
            {section !== "" && (
              <AnimatePresence>
                {width > 1024 && (
                  <motion.div
                    className="mr-12"
                    style={{
                      width: "350px",
                      minWidth: "350px",
                      maxWidth: "350px",
                    }}
                    initial={{ x: "-200%" }}
                    animate={{ x: 0 }}
                    exit={{ x: "-200%" }}
                    transition={{ damping: 200 }}
                  >
                    <ModulesSidebar />
                  </motion.div>
                )}
              </AnimatePresence>
            )}
            <MainSection />
            {section !== "" && <LinksSidebar />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
